export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q03_b.93db17c6.png";